import { useEffect, useState, useMemo } from "react";
import { Select } from "antd";
import { useNavigate } from 'react-router-dom';
import dayjs from "dayjs";
import StockOsv from "./stock-osv";
import StockRest from "./stock-rest";
import StockDocs from "./stock-docs";
import StockFilter from "./stock-filter";
import { isMobile } from "@/extensions/design";

const Stock = ({ page }) => {
  const [mobilePage, setMobilePage] = useState("stock");
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(null);

  // Инициализация выбранных фильтров из localStorage при монтировании
  useEffect(() => {
    const savedFilter = localStorage.getItem('stockDocsFilter');
    if (savedFilter) {
      try {
        setSelectedFilters(JSON.parse(savedFilter));
      } catch (e) {
        console.warn('Ошибка при загрузке фильтра из localStorage:', e);
      }
    }
  }, []);

  const normalizeExternalFilter = (extFilter) => {
    if (!extFilter) return null;
    const normalized = { ...extFilter };
    if (normalized.dateFrom && typeof normalized.dateFrom === "string") {
      normalized.dateFrom = dayjs(normalized.dateFrom);
    }
    if (normalized.dateTo && typeof normalized.dateTo === "string") {
      normalized.dateTo = dayjs(normalized.dateTo);
    }
    return normalized;
  };

  const externalFilter = useMemo(() => {
    const normalized = normalizeExternalFilter(selectedFilters);
    if (!normalized) return null;
    // На мобильной вёсртке, дочерние компоненты сами управляют фильтрами по датам, т.к. они не входят в модальное окно с доп.фильтрами.
    // Поэтому отправялем только фильтры без дат в externalFilter.
    const { dateFrom, dateTo, ...rest } = normalized;
    return Object.keys(rest).length > 0 ? rest : null;
  }, [selectedFilters]);

  const handleFilterClose = (filters) => {
    setShowFilter(false);
    if (filters) setSelectedFilters(filters);
  };

  const [items, setItems] = useState([]);
  const [allClientOutOptions, setAllClientOutOptions] = useState([]);
  const [allClientInOptions, setAllClientInOptions] = useState([]);

  // Список страниц для мобильного селектора
  const pages = [
    { title: "Текущие остатки", link: "stock" },
    { title: "ОСВ", link: "stock-osv"},
    { title: "Накладные", link: "stock-docs"}
  ];

  const getPage = () => {
    switch (page){
      case "stock": return <StockRest />
      case "stock-osv": return <StockOsv />
      case "stock-docs": return <StockDocs filter={externalFilter} onItemsChange={(newItems) => {setItems(newItems)}} onOptionsChange={(out, in_) => {setAllClientOutOptions(out); setAllClientInOptions(in_)}}/>
      default: return null;
    }
  }

  const getItem = (title, link) => <a 
    className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} 
    href={`${link}`}>{title}</a>

  return !isMobile ? (
    <div className="col-one-main">
      <div className="col-one-title">
        {getItem("Текущие остатки", "stock")}
        {getItem("ОСВ", "stock-osv")}
        {getItem("Накладные", "stock-docs")}
      </div>
      <div className="col-one-col">
        {getPage()}
      </div>
    </div>) : 
    (
      <div className="sport-form-content">
        <div className="col-one-main">
          <div className="col-one-col">
            <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Склад</div>
            <div className='selector-filer-section'>
              <Select value={page} onChange={(v) => { setMobilePage(v); navigate(`/${v}`); }} style={{width: "100%"}}>
                {pages.map(p => (
                  <Select.Option key={p.link} value={p.link}>
                    {p.title}
                  </Select.Option>
                ))}
              </Select>
              { page == "stock-docs" ? 
                (<img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>) :
              (<></>)}
              {showFilter && <StockFilter items={items} value={externalFilter} onClose={handleFilterClose} allClientOutOptions={allClientOutOptions} allClientInOptions={allClientInOptions} />}
            </div>
            {getPage()}
          </div>
        </div>
      </div>
    )
}

export default Stock;